import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useSearchBarStyles = makeStyles({
  root: {
    width: '100%',
    maxWidth: '30.75rem',
    flexShrink: 1,
    minWidth: '5rem',
  },
  searchBox: {
    width: '100%',
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('0.25rem'),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    '& input::placeholder': {
      color: tokens.colorNeutralForeground4,
    },
  },
  searchIcon: {
    color: tokens.colorBrandForeground2,
  },
});
